export default "__VITE_ASSET__DShgTExU__"